/*
 @flow
 @format
*/

import * as React from 'react';

import AlertComponent from '../AlertComponent';

type Props = { error: { name: string, message: string } } & React.ElementConfig<any>;

export default ({ error }: Props) => (
  <AlertComponent title="Error intentando conectar a la sesión">
    <pre>
      Código de error: ${error.name} / ${error.message}`
    </pre>
    <br />
    <br />
    <b>Por favor, compruebe lo siguiente y vuelva a refrescar la página:</b>
    <br />
    <div className="list-group">
      <a href="#" className="list-group-item list-group-item-action list-group-item-light">
        1. Su conexión a Internet funciona correctamente.
      </a>
      <br />
      <a href="#" className="list-group-item list-group-item-action list-group-item-light">
        2. No tiene ningún cortafuegos (<i>firewall</i>) instalado en su equipo o red.
      </a>
      <br />
    </div>
  </AlertComponent>
);
